import React, {useState, useEffect} from 'react'
import './TaskModelPopup.scss'

const TaskModelPopup = props => {
    const [position, setPosition] = useState({top:0, left:0});
    useEffect(()=>{
        //measure 
        const screen = document.querySelector('.TaskModel .Screen');
        const taskBounds = screen.getBoundingClientRect();

        const popup = document.querySelector('.TaskModel .TaskModelPopup .popup-body');
        const popupBounds = popup.getBoundingClientRect();

        console.log('task/pop', taskBounds.height, popupBounds.height)
        setPosition({
            'top':(taskBounds.height - popupBounds.height)/2,
        })
    },[])
    return (
        <div className={`TaskModelPopup ${props.class || ''} popup-animate`}>
            {props.scrim && <div className={`scrim`}></div>}
            <div className={`popup-body`} style={position}>
                <h1>{props.heading}</h1>
                <div className={`text`} dangerouslySetInnerHTML={{__html:props.text}}></div>
                <div className={`continue-button task-model-button`} onClick={props.onButtonClick}>{props.button}</div>
            </div>
        </div>
    )
}

export default TaskModelPopup